// Core navigation and shared UI strings.
export default {
  ur: {
    'nav.home': 'ہوم', 'nav.onboarding': 'آغاز', 'nav.agents': 'اے آئی ایجنٹس', 'nav.knowledge': 'نالج بیس',
    'nav.flows': 'فلو بلڈر', 'nav.testlab': 'ٹیسٹ لیب', 'nav.inbox': 'ان باکس', 'nav.tickets': 'ٹکٹس',
    'nav.contacts': 'رابطے', 'nav.leads': 'لیڈز', 'nav.workflows': 'ورک فلوز', 'nav.campaigns': 'مہمات',
    'nav.channels': 'چینلز', 'nav.integrations': 'انٹیگریشنز', 'nav.analytics': 'تجزیات', 'nav.team': 'ٹیم',
    'nav.billing': 'بلنگ', 'nav.developers': 'API اور ویب ہکس', 'nav.branding': 'برانڈنگ', 'nav.settings': 'ترتیبات',
    'nav.desk': 'ایجنٹ ڈیسک', 'nav.admin': 'پلیٹ فارم ایڈمن',
    'common.save': 'محفوظ کریں', 'common.cancel': 'منسوخ', 'common.delete': 'حذف کریں', 'common.search': 'تلاش',
    'common.create': 'بنائیں', 'common.edit': 'ترمیم', 'common.close': 'بند کریں', 'common.loading': 'لوڈ ہو رہا ہے…',
    'common.retry': 'دوبارہ کوشش کریں', 'common.signout': 'سائن آؤٹ',
    'presence.online': 'آن لائن', 'presence.away': 'دور', 'presence.offline': 'آف لائن',
    'auth.signin': 'سائن ان', 'auth.signup': 'اکاؤنٹ بنائیں', 'auth.email': 'ای میل', 'auth.password': 'پاس ورڈ',
  },
  ar: {
    'nav.home': 'الرئيسية', 'nav.onboarding': 'البدء', 'nav.agents': 'وكلاء الذكاء الاصطناعي', 'nav.knowledge': 'المعرفة',
    'nav.flows': 'منشئ التدفقات', 'nav.testlab': 'مختبر الاختبار', 'nav.inbox': 'صندوق الوارد', 'nav.tickets': 'التذاكر',
    'nav.contacts': 'جهات الاتصال', 'nav.leads': 'العملاء المحتملون', 'nav.workflows': 'سير العمل', 'nav.campaigns': 'الحملات',
    'nav.channels': 'القنوات', 'nav.integrations': 'التكاملات', 'nav.analytics': 'التحليلات', 'nav.team': 'الفريق',
    'nav.billing': 'الفوترة', 'nav.developers': 'API والويب هوك', 'nav.branding': 'العلامة التجارية', 'nav.settings': 'الإعدادات',
    'nav.desk': 'مكتب الوكيل', 'nav.admin': 'إدارة المنصة',
    'common.save': 'حفظ', 'common.cancel': 'إلغاء', 'common.delete': 'حذف', 'common.search': 'بحث',
    'common.create': 'إنشاء', 'common.edit': 'تعديل', 'common.close': 'إغلاق', 'common.loading': 'جارٍ التحميل…',
    'common.retry': 'أعد المحاولة', 'common.signout': 'تسجيل الخروج',
    'presence.online': 'متصل', 'presence.away': 'بعيد', 'presence.offline': 'غير متصل',
    'auth.signin': 'تسجيل الدخول', 'auth.signup': 'إنشاء حساب', 'auth.email': 'البريد الإلكتروني', 'auth.password': 'كلمة المرور',
  },
};
